import { SendEmailMessage, Trigger, WebsiteContentMessage } from 'sections/onsite-campaigns/types';
import { CampaignEditorState, CampaignMessage } from '../../../contexts/CampaignEditorState';
import { CampaignInfo } from '../types';
import { SplitTestsState } from '../../../tabs/CampaignWorkflowTab/state/SplitTests/SplitTestsState';

interface MapResult {
  campaignInfo: CampaignInfo;
  trigger: Trigger;
  onsiteMessages: WebsiteContentMessage[];
  offsiteMessages: SendEmailMessage[];
  splitTests: SplitTestsState;
  branchNames: string[];
}

export class StateToWorkflowMapper {
  private static mapCampaignInfo(state: CampaignEditorState): CampaignInfo {
    return {
      name: state.name,
      allowList: state.allowList,
      scheduling: state.scheduling,
    };
  }

  private static mapTrigger(state: CampaignEditorState): Trigger {
    return state.trigger;
  }

  private static mapOnsiteMessages(state: CampaignEditorState): WebsiteContentMessage[] {
    return Object.keys(state.messages).reduce((prev, curr) => {
      const message: CampaignMessage<any> = state.messages[curr];

      if (message.messageType === 'onsite') {
        return [...prev, message];
      } else {
        return prev;
      }
    }, []);
  }

  private static mapOffsiteMessages(state: CampaignEditorState): SendEmailMessage[] {
    return Object.keys(state.messages).reduce((prev, curr) => {
      const message: CampaignMessage<any> = state.messages[curr];

      if (message.messageType === 'offsite') {
        return [...prev, message];
      } else {
        return prev;
      }
    }, []);
  }

  private static mapBranchNames(state: CampaignEditorState): string[] {
    return Object.keys(state.branches).map(k => state.branches[k].name);
  }

  public static map(state: CampaignEditorState): MapResult {
    const campaignInfo: CampaignInfo = StateToWorkflowMapper.mapCampaignInfo(state);
    const trigger: Trigger = StateToWorkflowMapper.mapTrigger(state);
    const onsiteMessages: WebsiteContentMessage[] = StateToWorkflowMapper.mapOnsiteMessages(state);
    const offsiteMessages: SendEmailMessage[] = StateToWorkflowMapper.mapOffsiteMessages(state);
    const splitTests = state.splitTests;
    const branchNames: string[] = StateToWorkflowMapper.mapBranchNames(state);

    return {
      campaignInfo,
      trigger,
      onsiteMessages,
      offsiteMessages,
      splitTests,
      branchNames,
    };
  }
}
